import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import CustomSelect from "../Form/CustomSelect";
import { ProductCard } from "../global/ProductCard";

export const ShopSection = ({ data }) => {
  const [word, setWord] = React.useState("");
  const [filterValue, setFilterValue] = React.useState("");
  const [filteredData, setFilteredData] = React.useState([]);
  const sortData = ["Recently Added", "Best Seller", "Price: High - Low", "Price: Low - High"];

  const handleChange = (e) => setWord(e.target.value);

  React.useEffect(() => {
    const map = {
      "Recently Added": "recently-added",
      "Best Seller": "best-seller",
      "Price: High - Low": "price-high-low",
      "Price: Low - High": "price-low-high",
    };
    setFilterValue(map[word] || "");
  }, [word]);

  React.useEffect(() => {
    let result = [...data];
    if (filterValue === "recently-added") result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    else if (filterValue === "best-seller") result.sort((a, b) => b.count - a.count);
    else if (filterValue === "price-high-low") result.sort((a, b) => b.price - a.price);
    else if (filterValue === "price-low-high") result.sort((a, b) => a.price - b.price);
    setFilteredData(result);
  }, [filterValue, data]);

  const [page, setPage] = React.useState(1);
  const itemsPerPage = 12;
  const visibleProducts = filteredData.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  return (
    <Box sx={{ px: { xs: 2, sm: 4, md: 6, lg: 10 }, py: { xs: 4, md: 8 } }}>
      {/* Filter bar */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography sx={{ fontSize: 13, color: "#9ca3af", letterSpacing: "0.02em" }}>
          {filteredData.length} products
        </Typography>
        <CustomSelect value={word} data={sortData} onClick={handleChange} />
      </Box>
      <Divider sx={{ mb: { xs: 3, md: 4 } }} />

      <Grid container spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
        {visibleProducts.map((item, index) => (
          <Grid item xs={12} sm={4} md={3} key={index}>
            <ProductCard
              id={item.id}
              imgSrc={item.imgSrc}
              title={item.name}
              path={`/shop/view/${item.slug}/${item.id}`}
              price={item.price}
              slug={item.slug}
              limit={item.stock}
            />
          </Grid>
        ))}
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "center", py: { xs: 6, md: 8 } }}>
        <Pagination
          count={Math.ceil(data.length / itemsPerPage)}
          page={page}
          shape="rounded"
          color="primary"
          onChange={(_, value) => setPage(value)}
        />
      </Box>
    </Box>
  );
};
